import type { StyleValue } from "../../../BuilderUI/StyleValue.types";
import type { AlignmentOption } from "../ModifiedStyleAttributes/objectAlignment";

export const getAlignmentOptions = (
  defaultValue: AlignmentOption = "center",
): StyleValue => ({
  type: "string",
  value: defaultValue,
});

export interface MarginValues {
  marginBottom: string;
  marginLeft: string;
  marginRight: string;
  marginTop: string;
}

export const convertMarginToPadding = (marginValues: MarginValues) => ({
  paddingTop: marginValues.marginTop,
  paddingBottom: marginValues.marginBottom,
  paddingLeft: marginValues.marginLeft,
  paddingRight: marginValues.marginRight,
});
